"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AdminCredits_1 = require("./AdminCredits");
exports.default = AdminCredits_1.AdminCredits;
